import { useI18n } from '@alife/panda-i18n';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { logCustom } from 'src/utils/tracker';
import { PanelType } from 'src/types';
import './index.scss';
export default function ReleaseNote(props) {
    const config = props.data;
    const $i18n = useI18n();
    useEffect(() => {
        logCustom(`EXP_${props.panelConfigCode}`, config, props.panelCode);
    }, []);
    return (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-release-note', onClick: () => {
            props?.onItemClick?.(PanelType.releaseNote);
            logCustom(`CLK_${props.panelConfigCode}`, config, props.panelCode);
        } },
        React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-release-note-block-title' },
            React.createElement("p", { className: 'cn-ui-intelli-assistant-panel-release-note-block-title-desc' },
                React.createElement("img", { src: 'https://img.alicdn.com/imgextra/i3/O1CN01K4tvLu1kviUDWhXBb_!!6000000004746-2-tps-32-32.png' }),
                ' ',
                $i18n.get({ id: 'FunctionOnlineNotification', dm: '功能上线通知' }))),
        React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-release-note-title' }, $i18n.get({
            id: 'DateUpdate',
            dm: '{date}更新',
        }, {
            date: dayjs(config?.releaseNotesTime).format($i18n.get({
                id: 'YYYYYearMMonthDDay_626793450',
                dm: 'YYYY年M月D日',
            }))
        })),
        React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-release-note-label' }, config.label)));
}
